import { gql } from "apollo-angular";
// platzierungen_kennzahlen_filialLagerBestand
export const gql_filialBestand = gql`
query filialBestaendeByFilter($skip: Int, $take: Int, $filter: SortimentPlatzierungFilterInput)
{ sortimentPlatzierung( skip: $skip take: $take where: $filter order: [] ) { totalCount, pageInfo { hasNextPage hasPreviousPage }

 items {
  novitaet {hauptkategorie wkz1 wkz2 }
  platzierungen {
  modulNumber
  kennzahlen {
  filialLagerBestand }}}
}}


  `
